import { UploadedMediaDto } from "@growth/dto";

import { api } from "./api";

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_IMAGE_TYPES = "image/png,image/jpeg,image/gif,image/webp,image/avif";

export const uploadImage = async (file: File): Promise<UploadedMediaDto> => {
  if (file.size > MAX_UPLOAD_BYTES) throw new Error("Images must be 10 MB or smaller");
  const form = new FormData();
  form.append("file", file);
  return (await api.post<UploadedMediaDto>("/media", form)).data;
};
